import type { FC } from 'react';
import type { RequestTemplateGroups } from '@/model/Request.model';
import { ApprovalSection } from '@/components/Studies/Show';
import FormRender from '@/components/UI/FormRender';
import { FormProvider, useForm } from 'react-hook-form-latest';

interface ApprovalFormSummaryProps {
  approval: {
    form_data: Record<string, unknown>;
    approval: {
      form: {
        groups: Array<RequestTemplateGroups>;
      };
    };
  };
}

const ApprovalFormSummary: FC<ApprovalFormSummaryProps> = ({ approval }) => {
  const formMethods = useForm({
    defaultValues: approval.form_data,
  });
  return (
    <FormProvider {...formMethods}>
      <FormRender
        groups={approval.approval.form.groups}
        groupContainer={ApprovalSection}
        submitted
        hookFormVersion="latest"
      />
    </FormProvider>
  );
};

export default ApprovalFormSummary;
